// This class represents files stored in a GCP bucket. Either the url or bucket location should be provided
// (url for external links, bucket location for gcp bucket storage)

export enum CASTFileStatus {
  LOADING = 'Loading',
  SCANNING = 'Scanning',
  ERROR = 'Error',
  SUCCESS = 'Success',
}
export class CASTFile {
  id?: string;
  fileName?: string;
  mimeType?: string;
  url?: string;
  bucketLocation?: string;
  description?: string;
  data?: File;
  status?: CASTFileStatus;

  constructor(
    fileName: string,
    mimeType: string,
    url?: string,
    bucketLocation?: string,
    status?: CASTFileStatus
  ) {
    this.id = null;
    this.fileName = fileName;
    this.mimeType = mimeType;
    this.url = url;
    this.bucketLocation = bucketLocation;
    this.status = status;
  }
}
